import type { PlaylistOption } from '../types/api.types'

/**
 * A playlist is playable as hold/ringback music if it's a stream or a list
 * with audio tracks. The seeded system playlists (Default, Christmas, Holiday,
 * Happy Acoustic) are streams: they have 0 tracks but must remain assignable.
 * Only an empty list playlist (no tracks) is unplayable — it'd play silence.
 *
 * `type` — not `url` — is the stream discriminator: the MOH server fills `url`
 * in on list playlists too after processing, so `!!url` would wrongly pass an
 * emptied list as playable. `track_count` is optional; when absent (an API
 * that omits it) we treat the playlist as playable so we never hide every
 * option.
 *
 * NOTE: this rule is duplicated in system-settings-ui `DefaultsSettingsTab`
 * and music-on-hold-ui `MusicOnHoldListPage` (separate PlaylistOption types).
 * Keep all three in sync if the definition changes.
 */
export const isPlayablePlaylist = (playlist: PlaylistOption): boolean =>
  playlist.type === 'stream' ||
  playlist.track_count == null ||
  playlist.track_count > 0
